import "./App.css";
import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import * as L from "leaflet";

import useFetch from "./useFetch";
import townsData from "./essex-ma-towns.json";
import { Notification, SiteLayers } from "./components";
import { useLegend, useWindowSize, useDebouncedValue } from "./hooks";
import { getTownColor } from "./utils";

function App() {
  const [mapData, setMapData] = useState([]);
  const [map, setMap] = useState(null);
  useLegend(map);

  const windowSize = useWindowSize();
  const debouncedWindowSize = useDebouncedValue(windowSize, 500);

  useEffect(() => {
    if (map) {
      map.fitBounds([
        [42.91497, -71.242184],
        [42.400634, -70.566206],
      ]);
    }
  }, [debouncedWindowSize, map]);

  // Fetch data from WP
  const { data: townsWPdata, error: ParticipantDataError } = useFetch(
    "https://www.eccf.org/wp-json/md-api/participants",
  );
  const { data: sitesWPdata, error: SiteDataError } = useFetch(
    "https://www.eccf.org/wp-json/md-api/sites",
  );

  useEffect(() => {
    if (Array.isArray(townsWPdata)) {
      const result = {
        ...townsData,
        features: townsData.features.reduce(
          (acc, curr) => [
            ...acc,
            {
              ...curr,
              properties: {
                ...curr.properties,
                broadband_access: townsWPdata.find(
                  (t) => t.town === curr.properties.TOWN_NAME,
                )?.value,
              },
            },
          ],
          [],
        ),
      };
      setMapData(result);
    }
  }, [townsWPdata]);

  return (
    <div className="App">
      {ParticipantDataError ||
        (SiteDataError && (
          <Notification
            type="danger"
            message="Whoops! There was an error fetching data. Please refresh the page."
          />
        ))}
      <MapContainer
        center={[42.68392, -70.931308]}
        zoom={10}
        scrollWheelZoom={false}
        style={{
          height: window.innerHeight,
          maxHeight: "100%",
          width: window.innerWidth,
          maxWidth: "100%",
        }}
        whenCreated={setMap}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        />

        <SiteLayers markers={sitesWPdata} />
        <GeoJSON
          key={mapData.length}
          attribution="&copy; credits due..."
          data={mapData}
          style={getTownColor}
          onEachFeature={(feature, layer) => {
            layer.bindPopup(feature.properties.TOWN_NAME, {
              closeButton: false,
              offset: L.point(0, -20),
            });
          }}
          eventHandlers={{
            mouseover: ({ layer }) => {
              layer.openPopup();
              layer.setStyle(getTownColor(layer.feature, 1));
            },
            mouseout: ({ layer }) => {
              layer.closePopup();
              layer.setStyle(getTownColor(layer.feature));
            },
          }}
        />
      </MapContainer>
    </div>
  );
}

export default App;
